import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function TabelContent({ deitalInvoice }) {
  return (
    <>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        {deitalInvoice.map((row, index) => (
          <List
            sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
            key={index}
          >
            <ListItem>
              <ListItemText primary="מחיר" secondary={row["QPRICE"]} />
              <ListItemText
                primary="כמות"
                secondary={row["TQUANT"]}
                sx={{ paddingRight: "1.4rem" }}
              />
              <ListItemText
                primary='מק"ט'
                secondary={row["PARTNAME"]}
                sx={{ paddingRight: "1.4rem" }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                secondary={
                  <Typography variant="body1" style={{ fontSize: 11 }}>
                    {row["PDES"]}
                  </Typography>
                }
              />
            </ListItem>

            <Divider />
          </List>
        ))}
      </Box>
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        {deitalInvoice.map((row, index) => (
          <List sx={{ width: "100%", bgcolor: "background.paper" }} key={index}>
            <ListItem>
              <ListItemText
                secondary={
                  <Typography variant="subtitle1" sx={{fontWeight: "bold"}}>
                    {row["PDES"]}
                  </Typography>
                }
              />
            </ListItem>
            <ListItem>
              <ListItemText primary="מחיר" secondary={row["QPRICE"]} />
              <ListItemText
                primary="כמות"
                secondary={row["TQUANT"]}

              />
              <ListItemText
                primary='מק"ט'
                secondary={row["PARTNAME"]}
              />
            </ListItem>

            <Divider />
          </List>
        ))}
      </Box>
    </>
  );
}

export default TabelContent;
